/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  ITimeFrameOracle,
  ITimeFrameOracleInterface,
} from "../../../contracts/interfaces/ITimeFrameOracle";

const _abi = [
  {
    inputs: [],
    name: "TimeframeOracle_InvalidTimeFrame",
    type: "error",
  },
  {
    inputs: [],
    name: "TimeframeOracle_OnlyWriter",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [],
    name: "FrameReset",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "ITimeFrameOracle.Time",
        name: "startTime",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "ITimeFrameOracle.Time",
        name: "endTime",
        type: "uint256",
      },
    ],
    name: "FrameSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "writer",
        type: "address",
      },
    ],
    name: "WriterSet",
    type: "event",
  },
  {
    inputs: [],
    name: "getEnd",
    outputs: [
      {
        internalType: "ITimeFrameOracle.Time",
        name: "endTime",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStart",
    outputs: [
      {
        internalType: "ITimeFrameOracle.Time",
        name: "startTime",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTimeFrame",
    outputs: [
      {
        components: [
          {
            internalType: "ITimeFrameOracle.Time",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "ITimeFrameOracle.Time",
            name: "endTime",
            type: "uint256",
          },
        ],
        internalType: "struct ITimeFrameOracle.TimeFrame",
        name: "timeFrame",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "reset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "ITimeFrameOracle.Time",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "ITimeFrameOracle.Time",
            name: "endTime",
            type: "uint256",
          },
        ],
        internalType: "struct ITimeFrameOracle.TimeFrame",
        name: "timeFrame",
        type: "tuple",
      },
    ],
    name: "setFrame",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dataWriter",
        type: "address",
      },
    ],
    name: "setWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class ITimeFrameOracle__factory {
  static readonly abi = _abi;
  static createInterface(): ITimeFrameOracleInterface {
    return new Interface(_abi) as ITimeFrameOracleInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ITimeFrameOracle {
    return new Contract(address, _abi, runner) as unknown as ITimeFrameOracle;
  }
}
